import { useTranslation, Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import React, {useEffect} from 'react';
import gsap from 'gsap';

import Footer from '../components/Footer';

import '../static/css/restaurantPage.css';

import { ReactComponent as WhiteLine } from '../assets/restaurant-page/hero-section-vertical-line.svg';

import AboutRestaurantSectionImage from '../assets/img/restaurant-page/about-restaurant.jpg';

import OazaGazeta from '../assets/img/restaurant-page/oaza-gazeta.jpg';

import MenuTypeOne from '../assets/img/restaurant-page/menu-types/type-one.jpg';
import MenuTypeTwo from '../assets/img/restaurant-page/menu-types/type-two.jpg';
import MenuTypeThree from '../assets/img/restaurant-page/menu-types/type-three.jpg';
import MenuTypeFour from '../assets/img/restaurant-page/menu-types/type-four.jpg';
import MenuTypeFive from '../assets/img/restaurant-page/menu-types/type-five.jpg';

const RestaurantPage = () => {

    const { t, i18n } = useTranslation();

    useEffect(() => {
        gsap.fromTo(".restaurant-page-hero-section-images", {
            backgroundSize: "200%"
        }, {
            backgroundSize: "100%",
            duration: 1,
            delay: 0.3
        });

        const heroParallax = gsap.timeline({
            scrollTrigger: {
                trigger: '.hero-section',
                start: '20% top',
                end: 'bottom top',
                scrub: true
            }
        });
        heroParallax.to('.restaurant-hero-section-background-image', {backgroundPosition: "50% 150%"});
    }, [])

  return (
    <div>
        <section className='container-fluid m-0 p-0 position-relative d-flex flex-column justify-content-around align-items-center z-0 hero-section' style={{minHeight: "100vh"}}>
            <div className='col-12 position-absolute z-1 restaurant-hero-section-background-image' style={{height: "100vh"}}></div>

            <div className='col-11 col-lg-10 position-relative z-2 mx-auto mb-5' style={{marginTop: "15rem"}}>
              <h1 className='text-title-5 text-white text-center font-jost-light mb-0'>OAZA RESTAURANT</h1>
              <p className='text-white text-center font-mont-light fs-5'>{t('restaurant_page_hero_section_catch_phrase')}</p>
            </div>

            <div className='col-12 d-flex justify-content-center align-items-center z-3'>
                <WhiteLine />
            </div>

            <div className='col-11 position-relative z-2 d-flex h-auto justify-content-center justify-content-md-center mb-5 mt-5 pb-5'>
              <a href='/menu/' target="_blank" className='text-white fs-4 px-5 menu-btn font-jost-light' style={{ padding: "2.7%"}}>
                <span className="frame" aria-hidden="true"></span>
                
                {t('menu_button')}
              </a>
            </div>
        </section>

        <section className='col-12 d-flex flex-column justify-content-around align-items-center pb-2' style={{minHeight: "100vh"}}>
            <div className='col-11 d-flex flex-column flex-md-row justify-content-between align-items-center mb-4 mt-5 my-10'>
                <div className='col-11 col-md-7 d-flex flex-column justify-content-center align-items-center'>
                    <div className='col-md-9 col-lg-8 col-xl-7 bg-color-dark-grey mb-4 ms-5 me-5' style={{height: "1px"}}></div>
                    <div className='col-11 col-md-9 col-lg-7 col-xl-6 me-4'>
                        <h1 className='fs-1 font-mont-light my-4 ps-2 text-md-start text-center about-restaurant-title'><Trans i18nKey="restaurant_page_about_restaurant_title" components={{ br: <br className='about-restaurant-title-break'/> }} /></h1>
                        <p className='ps-2 font-montserrat-regular text-md-start text-center about-restaurant-text' style={{fontSize: "calc(4px + 1vw)", lineHeight: "1.2"}}><Trans i18nKey="restaurant_page_about_restaurant_description" components={{ br: <br/> }} /></p>
                    </div>
                </div>

                <div className='col-10 col-md-5'>
                    <img src={AboutRestaurantSectionImage} className='img-fluid' />
                </div>
            </div>

            <div className='col-7 bg-color-dark-grey mb-5' style={{height: "1px"}}></div>
        </section>

        <section className='col-12 more-about-restaurant-section-background-image d-flex justify-content-start align-items-center' style={{height: "100vh"}}>
            <div className='col-12 col-10-half position-relative bg-color-dark-blue mb-5 d-flex align-items-end pb-5 h-75'>
                <h1 className='more-about-restaurant-section-title font-cormorant-sc-bold'><Trans i18nKey="restaurant_page_about_taste_title" components={{ br: <br className='about-restaurant-title-break'/> }} /></h1>
                
                <div className='col-12 col-sm-8 d-flex flex-column flex-sm-row justify-content-between align-items-center align-items-sm-start offset-sm-3 mb-1 more-about-restaurant-description-container'>
                    <div className='col-10 col-sm-5 d-flex align-items-start offset-sm-1 px-3 px-sm-0'>
                        <p className='more-about-restaurant-section-description font-montserrat-light text-center text-sm-start'><Trans i18nKey="restaurant_page_about_taste_description_1" /></p>
                    </div>

                    <div className='col-10 col-sm-5'>
                        <p className='more-about-restaurant-section-description font-montserrat-light text-center text-sm-start'><Trans i18nKey="restaurant_page_about_taste_description_2" /></p>
                    </div>
                </div>
            </div>
        </section>

        <section className='overflow-hidden'>
            <div className='mt-5 menu-types-title-container'>
                <h1 className='menu-types-title font-cormorant-sc-bold text-center'><Trans i18nKey="restaurant_page_our_menu_title" /></h1>
            </div>

            <div className='col-12 position-relative d-flex align-items-center pb-5 menu-types' style={{height: "100vh"}}>
                <div className='col-12 position-relative d-flex flex-column flex-md-row justify-content-around justify-content-sm-between align-items-center h-75 z-2 menu-type-photos-container'>
                    <Link to={"/static/menuPDF/regular-menu.pdf"} target="_blank" className='menu-type-photo type-one position-relative'>
                        <img src={MenuTypeOne} className='menu-type-image' />
                        <p className='col-12 font-cormorant-sc-bold text-center fs-4 position-absolute bottom-0 mb-5' style={{color: "#EBDFD4"}}><Trans i18nKey="restaurant_page_our_menu_main" /></p>
                    </Link>

                    <Link to={"/static/menuPDF/bar-menu.pdf"} target="_blank" className='menu-type-photo type-two position-relative' style={{marginTop: "7rem"}}>
                        <img src={MenuTypeTwo} className='menu-type-image' />
                        <p className='col-12 font-cormorant-sc-bold text-center fs-4 position-absolute bottom-0 mb-5' style={{color: "#EBDFD4"}}><Trans i18nKey="restaurant_page_our_menu_drinks" /></p>
                    </Link>

                    <Link to={"/static/menuPDF/deserts-menu.pdf"} target="_blank" className='menu-type-photo type-three position-relative'>
                        <img src={MenuTypeThree} className='menu-type-image' />
                        <p className='col-12 font-cormorant-sc-bold text-center fs-4 position-absolute bottom-0 mb-5' style={{color: "#EBDFD4"}}><Trans i18nKey="restaurant_page_our_menu_desserts" /></p>
                    </Link>

                    <Link to={"/static/menuPDF/wine-menu.pdf"} target="_blank" className='menu-type-photo type-four position-relative' style={{marginBottom: "7rem"}}>
                        <img src={MenuTypeFour} className='menu-type-image' />
                        <p className='col-12 font-cormorant-sc-bold text-center fs-4 position-absolute bottom-0 mb-5' style={{color: "#EBDFD4"}}><Trans i18nKey="restaurant_page_our_menu_wine" /></p>
                    </Link>


                    <Link to={"/static/menuPDF/breakfast-menu.pdf"} target="_blank" className='menu-type-photo type-five position-relative'>
                        <img src={MenuTypeFive} className='menu-type-image' />
                        <p className='col-12 font-cormorant-sc-bold text-center fs-4 position-absolute bottom-0 mb-5' style={{color: "#EBDFD4"}}><Trans i18nKey="restaurant_page_our_menu_breakfast" /></p>
                    </Link>
                </div>

                <div className='menu-types-background-half-dark m-0 p-0'></div>
            </div>
        </section>
        
        <section className='position-relative d-flex flex-row opening-hours-section' style={{minHeight: "85vh"}}>
            <div className='col-12 col-sm-6 opening-hours-dark-container d-flex py-3' style={{backgroundColor: "#191A1A", minHeight: "80vh", padding: "11px"}}>
                <div className='flex-1 w-100 border border-1 border-white d-flex justify-content-center align-items-center' style={{backgroundColor: "#191A1A"}}>
                    <div>
                        <p className='text-white font-montserrat-regular fs-3 fs-sm-6 opening-hours-text text-center mb-5'><Trans i18nKey="restaurant_page_working_hours_title" /></p>

                        <p className='text-white font-montserrat-regular fs-4 opening-days text-center my-4'><Trans i18nKey="restaurant_page_working_hours_restaurant" /></p>

                        <p className='text-center font-montserrat-regular fs-5 opening-hours my-4 py-2' style={{color: "#6A6A6A"}}>08:00 - 21:00</p>

                        <p className='text-white font-montserrat-regular fs-4 opening-days text-center my-4'><Trans i18nKey="restaurant_page_working_hours_bar" /></p>

                        <p className='text-center font-montserrat-regular fs-5 opening-hours my-4 py-2' style={{color: "#6A6A6A"}}>08:00 - 22:00</p>
                    </div>
                </div>
            </div>

            <div className='col-6 opening-hours-white-container d-flex py-3' style={{minHeight: "85vh", padding: "11px"}}>
                <div className='flex-1 w-100 border border-1 border-black d-flex justify-content-center align-items-center'>
                    <div className='col-12 col-sm-10 col-md-8 col-lg-5 p-4'>
                        <img src={OazaGazeta} className='img-fluid' />
                    </div>
                </div>
            </div>
        </section>

        <section className='col-12 my-5 pt-4 d-flex flex-column align-items-center row-gap-5'>
            <div className='col-11 col-md-8 col-lg-6'>
                <p className='fs-4 font-montserrat-light text-center'><Trans i18nKey="restaurant_page_ending_catch_phrase" /></p>
            </div>

            <div className='col-7' style={{height: "2px", backgroundColor: "#6A6A6A"}}></div>
        </section>

        <Footer />
    </div>
  )
}

// const RestaurantPage = () => {

//     useEffect(() => {
//         gsap.fromTo(".restaurant-page-hero-section-images", {
//             backgroundSize: "200%"
//         }, {
//             backgroundSize: "100%",
//             duration: 1,
//             delay: 0.3
//         })
//     }, [])

//   return (
//     <div>
//         <section className='container-fluid bg-dark p-0 position-relative d-flex justify-content-center' style={{height: "100vh"}}>
//             <div className='col-11 header-offset'>
//                 <div className='col-lg-10 col-xxl-9'>
//                     <h1 className='text-color-dark-skin text-center text-md-start text-title-2 fw-bold'>Відчувайте насолоду у кожному шматочку.</h1>
//                     <p className='text-md-start font-mont-light col-12 col-md-10 col-xl-7 mt-3 text-white text-responsive-1 text-spread'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam maximus sapien ligula, in efficitur sapien commodo viverra. Aliquam tincidunt convallis sem sit amet lobortis. Nunc ullamcorper varius eleifend. Nam a ex diam. Proin eget ipsum dolor.</p>
//                 </div>

//                 <div className='col-12 h-50 position-absolute d-flex flex-row justify-content-center column-gap-5 overflow-x-hidden restaurant-page-hero-section-images-section'>
//                     <div className='col-6 col-md-5 col-lg-3 col-xxl-2 restaurant-page-hero-section-images'></div>
//                     <div className='col-6 col-md-5 col-lg-3 col-xxl-2 restaurant-page-hero-section-images'></div>
//                     <div className='col-6 col-md-5 col-lg-3 col-xxl-2 restaurant-page-hero-section-images'></div>
//                     <div className='col-6 col-md-5 col-lg-3 col-xxl-2 restaurant-page-hero-section-images'></div>
//                     <div className='col-6 col-md-5 col-lg-3 col-xxl-2 restaurant-page-hero-section-images'></div>
//                 </div>
//             </div>
//         </section>

//         <section className='container-fluid d-flex flex-row justify-content-center align-items-end my-5 restaurant-page-cuisine-section-container'>
//             <div className='col-11 d-flex flex-column flex-xl-row justify-content-center align-items-center align-items-xl-stretch column-gap-5'>
//                 <div className='col-12 col-md-10 col-xl-5 d-flex flex-column justify-content-start'>
//                     <h1 className='text-dark text-title-2 text-title-md-4 fw-bold'>Гармонія краси та смаку</h1>
//                     <p className='text-dark text-responsive-1 text-spread-md text-spread'>Відвідавши наш комплекс, ви маєте можливість насолодитися стравами гуцульської, української та європейської кухні в найвисокогірнішому ресторані України. Скуштувати ароматний трав’яний чай на відкритій терасі, з якої відкривається неймовірний пейзаж на вершини навколишніх гір.</p>
//                 </div>

//                 <div className='col-12 col-md-10 col-xl-5'>
//                     <img src={CuisineSectionImage} className='img-fluid' />
//                 </div>
//             </div>
//         </section>

//         <section className='container-fluid bg-color-dark d-flex flex-row justify-content-center align-items-end py-5' style={{minHeight: "50vh"}}>
//             <div className='col-11 d-flex flex-wrap justify-content-center column-gap-5 row-gap-5'>
//                 <div className='col-12'>
//                     <h1 className='text-white text-title-2 text-title-md-3 text-center fw-bold'>Створюйте незабутні спогади разом з нами</h1>
//                 </div>

//                 <div className='col-12 col-md-10 col-xl-5'>
//                     <img src={EventsSectionImage} className='img-fluid' />
//                 </div>

//                 <div className='col-12 col-md-10 col-xl-5 d-flex flex-column justify-content-between align-items-center align-items-lg-start'>
//                     <p className='text-white text-responsive-1 text-spread-md'>Відвідавши наш комплекс, ви маєте можливість насолодитися стравами гуцульської, української та європейської кухні в найвисокогірнішому ресторані України. Скуштувати ароматний трав’яний чай на відкритій терасі, з якої відкривається неймовірний пейзаж на вершини навколишніх гір.</p>
//                     <a href='/menu/' className='text-white fs-2 px-3 py-2 button-hover-right-fill-skin border border-2 border-color-skin menu-page-link-button'>Меню</a>
//                 </div>
//             </div>
//         </section>

//         <Footer />
//     </div>
//   )
// }

export default RestaurantPage